import { jsx as _jsx } from "react/jsx-runtime";
import Button from '@ingka/button';
export default ({ dataTestId, dataAutoFocus, ...props }) => (_jsx(Button, { ...props, "data-testid": dataTestId, "data-autofocus": dataAutoFocus }));
//# sourceMappingURL=SkapaButton.js.map